import { routeBuilder, SsoStatusClient } from '@is24at/react-utils';
import { universalFetch } from 'core/fetch';

export default new SsoStatusClient({
  fetch: universalFetch,
  prefix: routeBuilder.withMountRoot('/api'),
});
